import React from "react";
import StepsPostulation from "../../steps_postulation/StepsPostulation";
import MainFilter from '../content/MainFilter'
import { STEPS } from "@frontend/constants/initialValues";
const FilterFormMain = ({ lists, selection_process, hiring, readonly=false, mettlActive=false }) => {

  return (
    <div>
      <StepsPostulation steps={STEPS} current={2} readonly={readonly} />
      <MainFilter lists={lists} selection_process={selection_process} hiring={hiring} readonly={readonly} mettlActive={mettlActive} />
    </div>
  );
};

export default FilterFormMain;
